
import React from "react";
import { FormFieldType } from "@/types/form";

interface SectionHeaderProps {
  element: FormFieldType;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ element }) => {
  return (
    <div className="mb-6">
      <h2 className="text-xl font-semibold border-b border-gray-200 pb-2">{element.label}</h2>
    </div>
  );
};

export default SectionHeader;
